import { render, staticRenderFns } from "./modalAprobarCambioPrecio.vue?vue&type=template&id=73f0fc2c&"
import script from "./modalAprobarCambioPrecio.vue?vue&type=script&lang=js&"
export * from "./modalAprobarCambioPrecio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports